import { IUserProfile } from '../interfaces/IUserProfile.interface';

export class UserProfile implements IUserProfile {
	Id: number;
	FirstName: string;
    LastName: string;
    RoleId: number;
    SiteId: number;
    AvatarId: string;
    ContactEmail: string;
    ContactPhone: string;
    GroupId: number;
    GroupPendApproval: boolean;
}


// WEBPACK FOOTER //
// ./src/app/models/UserProfile.ts